import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

const ExperienceLetterDialog = ({ open, onClose, onSubmit, employee }) => {
  const [formData, setFormData] = useState({
    end_date: "",
    supervisor_name: "",
    supervisor_position: "",
  });

  const handleChange = (field) => (e) =>
    setFormData({ ...formData, [field]: e.target.value });

  const handleSubmit = () => {
    onSubmit(employee, formData);
    setFormData({ end_date: "", supervisor_name: "", supervisor_position: "" });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Generate Experience Letter</DialogTitle>
      <DialogContent dividers>
        <TextField
          margin="dense"
          label="End Date (e.g. 31-DEC-2025)"
          fullWidth
          value={formData.end_date}
          onChange={handleChange("end_date")}
        />
        <TextField
          margin="dense"
          label="Supervisor Name"
          fullWidth
          value={formData.supervisor_name}
          onChange={handleChange("supervisor_name")}
        />
        <TextField
          margin="dense"
          label="Supervisor Position"
          fullWidth
          value={formData.supervisor_position}
          onChange={handleChange("supervisor_position")}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExperienceLetterDialog;
